import React from 'react';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
export function AboutFounderSection() {
  return <section className="bg-black py-24" data-id="element-104">
      <div className="max-w-7xl mx-auto px-6 lg:px-12" data-id="element-105">
        <motion.div className="bg-gradient-to-br from-purple-500/10 to-cyan-500/10 border border-white/10 rounded-3xl p-8 lg:p-12" initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-106">
          <div className="flex flex-col lg:flex-row gap-8 items-center" data-id="element-107">
            <motion.img src="https://uploadthingy.s3.us-west-1.amazonaws.com/pxTQboBiYT6zUc74QDizUK/Brigitte_Tebow_%281%29.jpg" alt="Brigitte Tebow" className="w-48 h-48 rounded-2xl object-cover flex-shrink-0" initial={{
            opacity: 0,
            scale: 0.9
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: 0.2
          }} whileHover={{
            scale: 1.05
          }} data-id="element-108" />
            <div className="flex-1" data-id="element-109">
              <motion.h2 className="text-3xl md:text-4xl font-medium text-white mb-3" initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.6,
              delay: 0.3
            }} data-id="element-110">
                About the Founder
              </motion.h2>
              <motion.p className="text-xl text-purple-400 mb-6" initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.6,
              delay: 0.4
            }} data-id="element-111">
                Brigitte Tebow, CEO & Founder
              </motion.p>
              <motion.p className="text-white/80 leading-relaxed mb-6" initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.6,
              delay: 0.5
            }} data-id="element-112">
                Brigitte is a high-impact advisor and speaker who delivers
                premium insights at enterprise scale—trusted by clients who
                value speed, precision, and successful outcomes. With deep
                expertise in Cloud Data Strategy, Master & Reference Data
                Management (MDM/RDM), and Enterprise Data Governance, she brings
                specialized expertise to U.S. healthcare data management.
              </motion.p>
              <motion.div initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.6,
              delay: 0.6
            }} data-id="element-113">
                <Link to="/team" className="inline-flex items-center gap-2 px-6 py-3 bg-white text-black rounded-xl font-semibold hover:bg-white/90 transition-colors" data-id="element-114">
                  Meet the Team
                  <ArrowRight className="w-4 h-4" data-id="element-115" />
                </Link>
              </motion.div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}